module.exports = __webpack_public_path__ + "fonts/SofiaProSemiBold-Italic.48d45443.eot";